import { render, staticRenderFns } from "./marketplanbranch.vue?vue&type=template&id=0622ceb6&scoped=true&"
import script from "./marketplanbranch.vue?vue&type=script&lang=js&"
export * from "./marketplanbranch.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./marketplanbranch.vue?vue&type=style&index=1&id=0622ceb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0622ceb6",
  null
  
)

export default component.exports